export default __webpack_public_path__ + "static/media/Bahar-Sarlak-resume.1c19e5c2.doc";